import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { TURNKEY_OMNIBUS_FEATUREID } from '../constants';

import { isFeaturePresent } from '../util/CommonUtils';
import { ieSteps } from '../util/IEUtils';

import { getIEInitialData, resetState } from '../actions/turnkeyOmnibusActions';

import IEUniversityMessage from '../components/TurnkeyOmnibus/IEUniversity';
import IEPermission from '../components/TurnkeyOmnibus/IEPermission';
import Landing from '../components/TurnkeyOmnibus/Landing';
import SurveyDetails from '../components/TurnkeyOmnibus/SurveyDetails';
import CreateSurvey from '../components/TurnkeyOmnibus/CreateSurvey';
import { APP_ROOT_URL, DEFAULT_LANDING_PAGE } from '../actions/urlTypes';

class TurnkeyOmnibus extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  state = {}

  componentDidMount() {
    const { activeAccountId, isQtsEnabled, navFlow = false, impersonated } = this.props;
    if (impersonated) {
      this.context.router.push(`${APP_ROOT_URL}${DEFAULT_LANDING_PAGE}`);
      return;
    }
    if (!impersonated && isQtsEnabled && !navFlow) {
      this.props.getIEInitialData(activeAccountId);
    }
  }

  componentWillUnmount() {
    if (!this.props.impersonated) {
      this.props.resetState();
    }
  }

  renderStep = () => {
    const { activeStep } = this.props;
    switch (activeStep) {
      case ieSteps.SURVEY_LIST:
        return <Landing />;
      case ieSteps.SURVEY_DETAILS:
        return <SurveyDetails />;
      case ieSteps.CREATE_SURVEY:
        return <CreateSurvey />;
      default:
        return <Landing />;
    }
  }

  render() {
    const { universityUser, isQtsEnabled, impersonated } = this.props;

    if (impersonated) {
      return null;
    }
    if (universityUser || (isQtsEnabled && universityUser)) {
      return <IEUniversityMessage />;
    }
    if (!isQtsEnabled) {
      return <IEPermission />;
    }

    return <div className="ie">{this.renderStep()}</div>;
  }
}

TurnkeyOmnibus.propTypes = {
  universityUser: PropTypes.bool,
  activeStep: PropTypes.string,
  isQtsEnabled: PropTypes.bool,
  getIEInitialData: PropTypes.func,
  activeAccountId: PropTypes.number,
  resetState: PropTypes.func,
  navFlow: PropTypes.bool,
  impersonated: PropTypes.bool,
};

TurnkeyOmnibus.defaultProps = {
  universityUser: false,
  activeStep: ieSteps.SURVEY_LIST,
  isQtsEnabled: true,
  navFlow: false,
  impersonated: false,
};

const mapStateToProps = state => ({
  universityUser: state.login.loginResponse.data.universityUser,
  impersonated: state.login.loginResponse.data.impersonated,
  ieMRIStudies: state.qts.ieMRIStudies,
  isQtsEnabled: isFeaturePresent(
    TURNKEY_OMNIBUS_FEATUREID,
    state.userDetail.permissions
  ),
  activeAccountId: state.account.activeAccountId,
  activeStep: state.turnkeyOmnibus.activeStep,
  navFlow: state.turnkeyOmnibus.navFlow,
});

export default connect(
  mapStateToProps,
  { resetState, getIEInitialData }
)(TurnkeyOmnibus);
